<template>
  <div class="page message-list">
    <navigation sticky>消息中心</navigation>
    <div v-if="list && list.length" class="list-container">
      <div class="item" v-for="(item,index) in list" :key="index" :class="{unRead: item.read==='N'}"  @click="pushDetail(item)">
        <img src="./images/icon_tongzhi@2x.png"  class="img">
        <div class="msg-info">
          <div class="msg-top"><span class="msg-title">{{ item.title }}</span><span class="date-time">{{ renderDateTime(item.createTime) }}</span></div>
          <p v-html="item.summarize "></p>
          <div class="action-text">
            <!-- 承诺函 -->
            <template v-if="item.messageType === 'PROMISE_LETTER' && item.verificationMode !== 'NON'">去签章</template>
            <template v-else>去看看</template>
            ></div>
        </div>
      </div>
      
    </div>
    <section class="no-data" v-else>
      <img src="./images/img_xiaoxi_empty.png">
      <div class="tips">当前暂无更多消息</div>
    </section>


    <template>
      <p  class="loading" v-if="loading"><img src="./images/loading@2x.png" >正在加载更多数据</p>
      <p class="loading-mark">&nbsp;</p>
      <p class="no-more" v-if="!hasNextPage && list && list.length">已全部加载完毕</p>
    </template>
   
  </div>
</template>
<script>
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { mapActions } from 'vuex'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'

dayjs.extend(customParseFormat)
export default {
  name: 'message-list',
  data () {
    return { 
      loading: !false,
      pageNum: 1,
      pageSize: 10,
      hasNextPage: true,
      list: []
    }
  },
  async  mounted () {
    await this.getList()
    this.nextPageWatch()
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('message', ['messagePageList']),
    pushDetail (item) {
      switch (item.messageType) {
        case 'PROMISE_LETTER': // 承诺函
          this.$router.push(`/message/detail-promise?recordNo=${item.recordNo}`)
          break
        case 'URGE_LETTER': // 催告函
          if (hasNativeMethod('pdfMessageDetail')) {
            jsBridge('pdfMessageDetail', { messageId: item.recordNo })
          } else {
            this.$router.push(`/message/detail-letter?recordNo=${item.recordNo}`)
          }
          break
        default:
          break
      }
    },
    async getList () {
      this.loading = true
      clearTimeout(window.timer)
      window.timer = setTimeout(async () => {
        const { success, data } = await this.messagePageList({
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        this.loading = false
        if (success && data.content) {
          this.list = [...this.list, ...data.content]
        }
        this.hasNextPage = data.hasNextPage
        this.pageNum++
      }, 1000)
    },
    nextPageWatch () {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && this.hasNextPage) {
            this.getList()
          }
        })
      })
      observer.observe(document.querySelector('.loading-mark'))
    },

    renderDateTime (date) {
      const now = dayjs()
      const dateDayjs = dayjs(date)

      const isToday = now.isSame(dateDayjs, 'day')
      const isYesterday = now.subtract(1, 'day').isSame(dateDayjs, 'day')
      const isThisYear = now.isSame(dateDayjs, 'year')

      const formatTime = (dateDayjs) => {
        return dateDayjs.format('HH:mm')
      }

      if (isToday) {
        return `${formatTime(dateDayjs)}`
      } else if (isYesterday) {
        return `昨天 ${formatTime(dateDayjs)}`
      } else if (isThisYear) {
        return `${dateDayjs.format('MM/DD')} ${formatTime(dateDayjs)}`
      } else {
        return `${dateDayjs.format('YYYY/MM/DD')} ${formatTime(dateDayjs)}`
      }
    }
  }
}
</script>
<style lang='less' scoped>
@import "../../assets/less/mixin.less";

    .page.message-list {
        background-color: #fafafa;
        @keyframes loading {
          to {
            transform: rotateZ(360deg);
          }
        }
        .no-more {
          margin: 20px auto ;
          font-size: 24px;
          text-align: center;
          color: #999;
          padding-bottom: 20px;
        }
        .loading {
          display: flex;
          justify-content: center;
          gap:20px;
          align-items: center;
          color: #999;
          img{
            display: block;
            animation: loading 1s infinite linear;
            filter:brightness(0.5);
            width:24px;
            height:24px;
          }
           
            margin: 30px auto 0;
            font-size: 24px;
          }
        .list-container {
          background: #fff;
          margin-top: 20px;
          .msg-top {
            display: flex;
            justify-content: space-between;
            padding-bottom: 10px;
            .msg-title {
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              font-size: 32px;
              color: #333333;
              line-height: 32px;
            }
            .date-time {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 24px;
              color: #999999;
              line-height: 33px;
            }
          }
          .item {
            display: flex;
            padding: 30px;
            gap:16px;
            position: relative;
            .msg-info {
              flex:1
            }
            &.unRead:after {
              content: '';
              width: 16px;
              height: 16px;
              background: #FF0000;
              border-radius: 50%;
              position: absolute;
              left: 96px;
              top:22px;
              border:4px solid #fff
            }
            .img {
              width: 80px;  
              height:80px;
            }
            .action-text {
              border-bottom: 1px solid #eee;
              padding: 10px ;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 26px;
              color: #8EB2D8;
            }
            p{
              margin-top: 6px;
              font-size: 26px;
              padding-left: 10px;
              color: #666666;
              line-height: 37px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              max-height: 3em;
            }

          }
        }
        .no-data {
            width: 100%;
            text-align: center;
            overflow: hidden;
            position: absolute;

            img {
                width: 206px;
                height: 176px;
                margin-top: 360px;
            }

            .tips {
              font-size: 28px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
              line-height: 36px;
              margin-top: 37px;
            }

            .sub-tips {
              font-size:24px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:rgba(153,153,153,1);
              line-height:36px;
                margin-top: 5px;
            }
        }
    }
</style>